module.exports = __webpack_public_path__ + "static/media/example.8d01e063.mp3";